import api from "@/lib/axios";

export const interviewerService = {
  async storeInterviewer(data) {
    // Check if data is FormData (for image uploads) or regular object
    const isFormData = data instanceof FormData;
    
    const config = {};
    if (isFormData) {
      // Remove the default Content-Type header for FormData
      // Let axios automatically set multipart/form-data with boundary
      config.headers = {
        'Content-Type': undefined
      };
    }
    
    const response = await api.post('/v1/store-interviewer', data, config);
    return response.data;
  },

  async showInterviewers() {
    const response = await api.get('/v1/show-interviewers');
    return response.data;
  },
  async showPublicInterviewers() {
    const response = await api.get('/show-interviewers');
    return response.data;
  },

  async getAllInterviewers(page = 1, searchParams = {}) {
    // Build query parameters
    const queryParams = new URLSearchParams();
    
    // Always add page parameter
    queryParams.append('page', page);
    
    // Add any additional search parameters
    Object.entries(searchParams).forEach(([key, value]) => {
      if (value) {
        queryParams.append(key, value);
      }
    });
    
    const response = await api.get(`/v1/interviewers?${queryParams.toString()}`);
    return response.data;
  },

  async deleteInterviewer(id) {
    const response = await api.delete(`/v1/users/${id}`);
    return response.data;
  }
}; 